/**
 * JQuery
 */

// import $ from "jquery";

// window.jQuery = $;
// window.$ = $;

/**
 * Bootstrap
 */

import {
    Collapse,
    Dropdown,
    Alert,
    Button,
    Carousel,
    Modal,
    Offcanvas,
    Popover,
    ScrollSpy,
    Tab,
    Toast,
    Tooltip,
} from 'bootstrap';

/**
 * Slick
 */

import "slick-carousel";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

/**
 * GSAP
 */

import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);
window.gsap = gsap;

/**
 * AOS
 */

import AOS from "aos";
import "aos/dist/aos.css";

AOS.init();


import fadeInSection from "./fadeInSection.js";
import sliderGallery from "./sliderGallery.js"
import sliderGalleryNav from './sliderGalleryNav.js';
import sliderGalleryFor from './sliderGallertFor.js';

document.addEventListener('DOMContentLoaded', () => {
    fadeInSection();
    sliderGallery();
    sliderGalleryNav();
    sliderGalleryFor();
})
